import axios from 'axios'

export default class Pendencia {
  constructor(tokenBearer, url, unimedId) {
    this.url = `${url}/api/pendencias`
    this.tokenBearer = tokenBearer
    this.id = unimedId
    this.urlVersaoDocumento = `${url}/api/unimed/anexo/versaoTemp`
  }

  getPendencia(args = '') {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: `${this.url}/${args}`,
        headers: {
          Authorization: this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  async getDocumentoByHistorico(idVersao) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: `${this.urlVersaoDocumento}/${idVersao}`,
        headers: {
          Authorization: this.tokenBearer
        }
      }

      try {
        let responseGet = await axios(options)
        resolve(responseGet)
      } catch (err) {
        reject(err)
      }
    })
  }

  getRecibo(unimedId) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: `${this.url}/recibo/${unimedId}`,
        headers: {
          Authorization: this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  getPendenciasTotais() {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: `${this.url}/total`,
        headers: {
          Authorization: this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  postAprovarRecibo(unimedId) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'post',
        url: `${this.url}/aprovar/${unimedId}`,
        headers: {
          Authorization: this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  postNegarRecibo(unimedId) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'post',
        url: `${this.url}/negar/${unimedId}`,
        headers: {
          Authorization: this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }
}
